import {Object3D} from 'three'
import {BaseNumericLoader} from './BaseNumericLoader'
import {IRepaintable} from './interfaces/IObjectLoader'

type Repaint = () => void

export default class RedSphereLoader
  extends BaseNumericLoader
  implements IRepaintable
{
  private repaint: Repaint | null = null

  constructor() {
    super()
  }

  async waitForLoad(): Promise<void> {
    return Promise.resolve()
  }

  initRepaint(repaint: Repaint): void {
    this.repaint = repaint
  }

  clearAllSpheres(): void {
    this.clearAll()
  }

  /**
   * Получение сфер по числовому ключу (для обратной совместимости)
   * Возвращает readonly Record для защиты от изменений извне
   */
  get spheres(): Readonly<Record<number, Object3D>> {
    return this.getNumericObjects()
  }

  addSphere(center: [number, number]): Object3D | null {
    return null
  }

  stopAnimationLoop(): void {
    // Реализация при необходимости
  }

  removeSphere(id: number): void {
    const sphere = this.numericObjects[id]
    if (!sphere) return

    const sphereId = `sphere-${id}`
    this.threeLayer?.removeObject(sphereId)
    this.removeObjectFromCollection(sphereId)
    this.removeFromNumericCollection(id)
  }

  showAllSpheres(): void {
    // Реализация при необходимости
  }

  hideAllSpheres(): void {
    // Реализация при необходимости
  }
}
